"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemLogger = void 0;
var shared_1 = require("@cian/peperrors/shared");
var ELKLogs_1 = require("../Log/ELKLogs");
var SystemLogger = /** @class */ (function () {
    function SystemLogger(params) {
        this.transport = params.transport;
        this.errorFilter = params.errorFilter;
    }
    SystemLogger.prototype.error = function (error) {
        if (this.errorFilter && !this.errorFilter.approve(error)) {
            return;
        }
        var message = typeof error === 'string'
            ? new shared_1.UnknownError({
                message: error,
                domain: 'system-logger.SystemLogger.error.unknown-domain',
            })
            : error;
        this.transport.write((0, ELKLogs_1.createELKErrorLog)({
            message: message,
            level: 'error',
        }));
    };
    SystemLogger.prototype.fatal = function (error) {
        var message = typeof error === 'string'
            ? new shared_1.UnknownError({
                message: error,
                domain: 'system-logger.SystemLogger.fatal.unknown-domain',
            })
            : error;
        this.transport.write((0, ELKLogs_1.createELKErrorLog)({
            message: message,
            level: 'fatal',
        }));
    };
    return SystemLogger;
}());
exports.SystemLogger = SystemLogger;
//# sourceMappingURL=Logger.js.map